import { render } from "./WisdomCareVolunteersList.vue?vue&type=template&id=cd30bde8&scoped=true"
import script from "./WisdomCareVolunteersList.vue?vue&type=script&lang=js"
export * from "./WisdomCareVolunteersList.vue?vue&type=script&lang=js"

import "./WisdomCareVolunteersList.vue?vue&type=style&index=0&id=cd30bde8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd30bde8"]])

export default __exports__